import { type BoxProps, Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import Image from "next/image";
import { LinkCard } from "ui/link-card";
import { ArrowLink } from "ui/link";

const BACKGROUND_GRADIENT =
  "https://cdn.sanity.io/images/pwmfmi47/production/f712eaa379b47398a8c8e12dc45c5a307cb6a317-582x471.svg?w=1800";

export type CaseStudyCardProps = {
  quote: string;
  logo: string;
  customerName: string;
  href?: string;
};

export function CaseStudyCard({ quote, logo, customerName, href, ...props }: CaseStudyCardProps & BoxProps) {
  const cardContent = (
    <Flex borderRadius="lg" direction="column" w="100%" h="100%" gap={4} minH="200px">
      <Box pos="relative" w="200px" h="30px" maxW="60%">
        <Image
          fill
          src={logo + "?w=500"}
          alt={customerName + "."}
          sizes="100%"
          style={{ objectFit: "contain", objectPosition: "left" }}
        />
      </Box>

      {quote && (
        <Text fontSize="lg" mt={6}>
          {quote}
        </Text>
      )}

      {href && (
        <Flex w="100%" mt="auto">
          <ArrowLink href={href} variant="dark" mt={8}>
            Read the blog
          </ArrowLink>
        </Flex>
      )}
    </Flex>
  );

  if (href) {
    return (
      <LinkCard
        href={href}
        linkAriaLabel="Read the blog."
        target="_blank"
        borderRadius="lg"
        border="1px"
        borderColor="blue.100"
        backgroundImage={{ base: `url('${BACKGROUND_GRADIENT}')` }}
        backgroundRepeat="no-repeat"
        backgroundPosition="center"
        backgroundSize="cover"
        p={6}
        {...props}
      >
        {cardContent}
      </LinkCard>
    );
  }

  return (
    <Box
      border="1px"
      borderColor="blue.100"
      borderRadius="lg"
      backgroundImage={{ base: `url('${BACKGROUND_GRADIENT}')` }}
      backgroundRepeat="no-repeat"
      backgroundPosition="center"
      backgroundSize="cover"
      p={6}
      {...props}
    >
      {cardContent}
    </Box>
  );
}
